import { Pagination } from "react-bootstrap";

function GeneralShortPagination() {
  return (
    <div className="d-sm-flex justify-content-between mb-2 align-items-center">
      <div className="d-flex-wrap align-items-center gap-2 mb-0">
        <label>Items per Page</label>
        <select name="" className="dropdown-btm-grey px-2 py-1 fs-14px">
          <option value="5">10</option>
          <option value="15">15</option>
          <option value="20">20</option>
        </select>
        <label>1-10 of 35</label>
      </div>
      <div className="d-flex mt-2 mt-sm-0 enquiry-page-cont">
        <Pagination>
          <Pagination.First className="enquiry-pag-list" />
          <Pagination.Prev className="enquiry-pag-list" />
          <Pagination.Next className="enquiry-pag-list" />
          <Pagination.Last className="enquiry-pag-list" />
        </Pagination>
      </div>
    </div>
  );
}

export default GeneralShortPagination;
